/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CloudBackupPlan {
    
    constructor(cscom) {
        if (!(this instanceof CloudBackupPlan)) {
            return new CloudBackupPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/cloud-backup/list', null, data);
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/cloud-backup/view', null, data);
    }    
}
